/**
 * 默认主题
 */
export const colorEnum = {
  primary: "#0090ff", // 主题色
  // ---- 文字颜色Text ----
  colorMain: "#191d2e", // 强调/正文标题
  colorMinor: "#43475e", // 次强调/正文标题
  colorLess: "#686B7E", // 次要信息
  colorLess2: "#989BAA", // 次要信息
  colorLess3: "#3E4152",
  colorGrey: "#B0B4C5", // 置灰信息
  colorFFF: " #fff", // 纯白文字
  // ---- 线条颜色Line ----
  borderLine: "#D7D8DE", // 重/按钮描边
  hoverLine: "#BBBBC9", // 深/悬浮
  commonLine: "#E7E7F0", // 一般
  lightLine: "#F2F2F6", // 浅 / 分割线
};

export const defaultTheme = {
  token: {
    colorPrimary: colorEnum.primary, // 主题色
    colorText: colorEnum.colorMain, // 最深色
    borderRadius: 4, // 圆角
    colorTextTertiary: colorEnum.colorLess2, // 面包屑、upload icon、description
    colorTextQuaternary: colorEnum.colorGrey, // placeholder,分页disabled
    colorPrimaryBg: "transparent", // button浅背景色
    colorPrimaryHover: "#556cf6", // button悬浮
    colorBgContainerDisabled: "#8da1ff", // button disabled 背景颜色
    colorBorder: "#E8E8EF", // input select button等border颜色
    colorBorderSecondary: "#f0f0f0", // table border 颜色
    fontFamily:
      "ali-regular, PingFangSC-Regular, PingFang SC, Microsoft YaHei, Arial, 黑体, 宋体,sans-serif" // 字体
  },
  components: {
    Button: {
      colorBorder: colorEnum.borderLine, // 按钮边框颜色
      borderRadius: 2, // 按钮圆角
      colorLink: colorEnum.primary, // link button 主题色
      colorLinkHover: "#506dff", // link button hover颜色
      colorTextDisabled: colorEnum.colorFFF // button disabled 文本颜色
    },
    Menu: {
      lineWidthBold: 0,
      lineWidthFocus: 0,
      lineWidth: 0,
      colorItemBgHover: "#F6F8FF", // 悬浮色
      colorSubItemBg: colorEnum.colorFFF, // 副标题背景色
      itemMarginInline: 0, // 左右margin间距
      controlHeightLG: 44, // title高度
      colorItemText: colorEnum.colorLess3 // menu未选中字体颜色
    },
    Tabs: {
      colorText: colorEnum.colorLess
      // colorItemText: colorEnum.colorLess, // tab 未选中字体颜色
    },
    Radio: {
      colorText: colorEnum.colorLess
    },
    Select: {
      colorText: colorEnum.colorMain, // 下拉框文字颜色
      colorTextPlaceholder: colorEnum.colorMain, // placeholder颜色
      // fontFamily: 'ali-light,PingFangSC-light',
      controlItemBgActive: "#F2F4FF", // 悬浮背景色
      controlItemBgHover: "#F5F5F5", // hover悬浮背景色
      borderRadiusSM: 0 // 悬浮的圆角
    },
    Form: {
      colorTextHeading: colorEnum.colorMain // label标题颜色
    },
    Empty: {
      colorText: colorEnum.colorLess
    },
    Dropdown: {
      // controlItemBgActive: "#F2F4FF", // 悬浮背景色
      controlItemBgHover: "#F5F5F5" // hover悬浮背景色
    }
  }
};
